import CarLeftDrawerContainer from "../../../components/car/other/CarLeftDrawer";

const CarLeftDrawer = () => {
  return <CarLeftDrawerContainer />;
};

export default CarLeftDrawer;
